import { ReactNode } from 'react';
import cn from 'classnames';
import { useField } from 'formik';
import MaskedInput from 'react-text-mask';

import Text from '@/components/common/Text/Text';

import '../InputField/InputField.style.scss';

type MaskedFieldProps = {
  name: string;
  /** Removes underscores per library: @url https://github.com/text-mask/text-mask/blob/master/componentDocumentation.md#guide */
  guide?: boolean;
  label: ReactNode;
  mask: Array<string | RegExp>;
  /** Post-processes the mask's conformed value against the raw input; see react-text-mask's `pipe`. */
  pipe?: (conformedValue: string, config: { rawValue: string }) => any;
  className?: string;
  type?: string;
  autoComplete?: string;
  placeholder?: string;
  onFocus?: () => void;
};

function MaskedField(props: MaskedFieldProps) {
  const {
    name,
    guide,
    label,
    mask,
    pipe,
    className,
    type = 'text',
    autoComplete,
    onFocus,
    placeholder
  } = props;
  const [field, meta /*, helpers */] = useField({ name });

  return (
    // This component borrows styles from InputField.
    // To keep styling modularity, we will add the InputField class
    // along with importing its stylesheet for efficiency's sake
    <div className={cn('InputField', 'MaskedField')}>
      <label className='InputField-label'>{label}</label>
      <MaskedInput
        className={cn('InputField-input', className, {
          Error: meta.touched && meta.error
        })}
        {...field}
        guide={guide}
        type={type}
        autoComplete={autoComplete}
        mask={mask}
        pipe={pipe}
        placeholder={placeholder}
        onFocus={onFocus}
      />
      {meta.touched && meta.error && (
        <div className='InputField-error'>
          <Text className='InputField-error-text'>{meta.error}</Text>
        </div>
      )}
    </div>
  );
}

export default MaskedField;
